import React, { PureComponent } from 'react';
import { DefaultCopyIconButton } from './DefaultCopyIconButton';

const COPY_TIMEOUT = 1000;

interface CopyButtonProps {
    value: string;
    onCopyClick?: () => void;
    render?: (hasCopied: boolean) => React.ReactNode;
}

interface CopyButtonState {
    hasCopied: boolean;
}

export class CopyButton extends PureComponent<CopyButtonProps, CopyButtonState> {
    static defaultProps = {
        render: DefaultCopyIconButton,
    };

    state: CopyButtonState = {
        hasCopied: false,
    };

    private handleClick = async () => {
        const { value, onCopyClick } = this.props;

        try {
            await navigator.clipboard.writeText(value);
            this.setState({ hasCopied: true });

            setTimeout(() => {
                this.setState({ hasCopied: false });
            }, COPY_TIMEOUT);

            onCopyClick?.();
        } catch (error) {
            console.error('Failed to copy text:', error);
        }
    };

    render() {
        const { render = DefaultCopyIconButton } = this.props;
        const { hasCopied } = this.state;

        return (
            <span onClickCapture={this.handleClick} role="button">
                {render(hasCopied)}
            </span>
        );
    }
}
